import { tw } from "tw-lite";

export const Card = tw("div")`
  rounded-md bg-white px-4 py-2 shadow-lg disabled:cursor-not-allowed dark:bg-neutral-800
`;
